import LockedFeatureCard from "@/components/LockedFeatureCard";

type CapabilityLockedCardProps = {
  capability: string;
  title?: string;
  description?: string;
  className?: string;
};

export function CapabilityLockedCard({ capability, ...rest }: CapabilityLockedCardProps) {
  return <LockedFeatureCard flag={capability} {...rest} />;
}

export default CapabilityLockedCard;
